import { Provider } from "react-redux";
import React from "react";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import configureStore from "../configureStore";
import App from "./App";
import { theme } from "../styles/theme";

const store = configureStore();
const Root = () => (
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  </Provider>
);

export default Root;
